export default __webpack_public_path__ + "static/media/banxa.2d0adb76.svg";